import {useEffect, useRef, useState} from 'react'

export const useQuestionTimer = (seconds: number, paused: boolean, onExpire: () => void) => {
  const [remaining, setRemaining] = useState(seconds)
  const onExpireRef = useRef(onExpire)
  onExpireRef.current = onExpire

  // Reset when seconds change (new question)
  useEffect(() => {
    setRemaining(seconds)
  }, [seconds])

  // Countdown logic
  useEffect(() => {
    if (paused) {
      return
    }

    if (remaining <= 0) {
      onExpireRef.current()
      return
    }

    const id = setTimeout(() => setRemaining((r) => r - 1), 1000)
    return () => clearTimeout(id)
  }, [remaining, paused])

  return {remaining, total: seconds}
}
